import ApiDrivenModel from "./ApiDrivenModel";

class ChatParticipant extends ApiDrivenModel {
}
ChatParticipant.ENDPOINT = "/Chat_Participant";

export default ChatParticipant;
